/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonSharedServiceTimeDropdownQueryResponse,
  GetApiV1PersonSharedServiceTimeDropdown401,
  GetApiV1PersonSharedServiceTimeDropdown500,
} from "../../types/personSharedController/GetApiV1PersonSharedServiceTimeDropdown.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonSharedServiceTimeDropdown } from "../../clients/personSharedController/getApiV1PersonSharedServiceTimeDropdown.ts";

export const getApiV1PersonSharedServiceTimeDropdownQueryKey = () =>
  [{ url: "/api/v1/person/shared/service-time-dropdown" }] as const;

export type GetApiV1PersonSharedServiceTimeDropdownQueryKey = ReturnType<
  typeof getApiV1PersonSharedServiceTimeDropdownQueryKey
>;

export function getApiV1PersonSharedServiceTimeDropdownQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonSharedServiceTimeDropdownQueryKey();
  return queryOptions<
    GetApiV1PersonSharedServiceTimeDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedServiceTimeDropdown401
      | GetApiV1PersonSharedServiceTimeDropdown500
    >,
    GetApiV1PersonSharedServiceTimeDropdownQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonSharedServiceTimeDropdown({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todas as opções do enumerador EServiceTime para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Lista de tempo de serviço para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/service-time-dropdown}
 */
export function useGetApiV1PersonSharedServiceTimeDropdown<
  TData = GetApiV1PersonSharedServiceTimeDropdownQueryResponse,
  TQueryData = GetApiV1PersonSharedServiceTimeDropdownQueryResponse,
  TQueryKey extends QueryKey = GetApiV1PersonSharedServiceTimeDropdownQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonSharedServiceTimeDropdownQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonSharedServiceTimeDropdown401
          | GetApiV1PersonSharedServiceTimeDropdown500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1PersonSharedServiceTimeDropdownQueryKey();

  const query = useQuery(
    {
      ...getApiV1PersonSharedServiceTimeDropdownQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonSharedServiceTimeDropdown401
      | GetApiV1PersonSharedServiceTimeDropdown500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
